import CustomTooltip from '../../../common/CustomTooltip/CustomTooltip';
import styles from '../FormContainer.module.css';

export default function OutOfStockTag() {
  return (
    <CustomTooltip title="This variant is out of stock">
      <div className={styles.outOfStockTag}>Out of Stock</div>
    </CustomTooltip>
  );
}
